import { getTicketType } from '../../utils/ticketType'

/**
 * Badge que representa el tipo de registro (ITIL) de un ticket.
 *
 * @component
 * @param {Object} props
 * @param {string} props.type - Slug del tipo (incident/request/problem/change).
 * @param {boolean} [props.sm=false] - Variante compacta (para tablas/kanban).
 * @returns {JSX.Element}
 */
const TicketTypeBadge = ({ type, sm = false }) => {
  const meta = getTicketType(type)
  return (
    <span
      className={`ticket-type-badge gm-tono ${sm ? 'is-sm' : ''}`}
      style={{ '--tono': meta.color }}
      title={meta.hint}
    >
      <i className={`fa-solid ${meta.icon}`} />
      <span>{meta.label}</span>
      <style>{`
        .ticket-type-badge {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          font-size: 0.75rem;
          font-weight: 600;
          padding: 3px 10px;
          border-radius: 99px;
          white-space: nowrap;
          line-height: 1.2;
        }
        .ticket-type-badge.is-sm {
          font-size: 0.68rem;
          padding: 2px 8px;
          gap: 4px;
        }
      `}</style>
    </span>
  )
}

export default TicketTypeBadge
